<template>
  <div className="animated">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>Data Table Jual Emas Partner
      </b-card-header>
      <b-card-body>
        <sell></sell>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import Sell from './Table'

  export default {
    name: 'gold-sell-partner',
    components: {
      Sell
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
